import { mapGetters } from "vuex";
import {validarVendaFutura} from "@/components/compra/ProdutosGerais/ValidacaoSugestao/VendaFutura/utils";

export default {
  computed: {
    ...mapGetters({
      mxProdutoSelecionado: "detalhe_produto/getProduto",
      mxEmbalagemMasterAtivada: "EmbalagemTelaDeCompras/getEmbalagemMaster",
    }),
  },
  methods: {
    verificarVendaFuturaValida(item) {
      return validarVendaFutura({
        quantidade_compra: Number(item.sugestao),
        quantidade_sugestao: Number(item.sugestao_fixa_convertivel),
        quantidade_venda_futura: Number(item.estoque_pendente)
      });
    },
    verificaSeSurgestaoEstoqueMinimo(item/*, pedido*/) {
      const valor_sugestao = item.sugestao ? parseFloat(item.sugestao) : parseFloat(item.qtde_pedido);
      const estoque_minimo = parseFloat(item.estoque_minimo);
      const estoque = parseFloat(item.estoque);
      const estoque_transito = parseFloat(item.estoque_transito);
      return (Number(valor_sugestao) + Number(estoque) + Number(estoque_transito)) >= Number(estoque_minimo);

      /* comendado, pois a logica de up e down não era mais usada e estava causando bug pois o systock estava aceitando como correta uma sugestao 1 lote minimo abaixo do estoque minimo(estetico)
      const valor_sugestao = item.sugestao ? parseFloat(item.sugestao) : parseFloat(item.qtde_pedido);
      const lote_minimo = parseFloat(item.lote_minimo);
      const estoque_minimo = parseFloat(item.estoque_minimo);
      const modulo = (valor_sugestao % lote_minimo);
      const up =  parseFloat(parseFloat(lote_minimo - modulo + valor_sugestao).toFixed(2));
      const down = parseFloat(parseFloat(up - lote_minimo).toFixed(2));

      if (!!pedido && valor_sugestao > up) return true;

      return estoque_minimo == up || estoque_minimo == down || valor_sugestao >= estoque_minimo;
     */
    },
    verificaSeMultiploDeLoteMinimo(item) {
      if (!item.lote_minimo) return false;

      const sugestao = item.sugestao
        ? parseFloat(item.sugestao).toFixed(4)
        : parseFloat(item.qtde_pedido).toFixed(4);

      const loteMinimo = parseFloat(item.lote_minimo).toFixed(4);

      // if (localStorage.config_lote_minimo_a_partir_de === 'S' && Number(sugestao) >= Number(loteMinimo)) {
      //   return true;
      // }

      const modulo = (sugestao % loteMinimo).toFixed(4);

      return (modulo == 0 || modulo == loteMinimo);
    },
    converteEmbalagemValor(valor) {
      const multiploCompra = this.mxProdutoSelecionado.multiplo_compra || 1;

      if (this.mxProdutoSelecionado.tipo_fator_conversao === 'M') {
        return this.mxEmbalagemMasterAtivada ? (valor * multiploCompra) : valor;
      }

      return this.mxEmbalagemMasterAtivada ? (valor / multiploCompra) : valor;
    },
    converterEmbalagemItemsCompra(itens){
      const CONVERSAO_EMBALAGEM = item => {
        const item_por_converter = {...item};

        if (item.tipo_fator_conversao === 'M') {
          return (!this.embalagemMasterAtivada)
            ? this.converterParaEmbMaster(item_por_converter)
            : this.converterParaEmbMinima(item_por_converter);
        }

        return (this.embalagemMasterAtivada)
          ? this.converterParaEmbMaster(item_por_converter)
          : this.converterParaEmbMinima(item_por_converter);
      }

      return itens.map(CONVERSAO_EMBALAGEM);
    },
    converterParaEmbMaster(item){
      item.estoque_pendente = (item.estoque_pendente / item.multiplo_compra);
      item.sugestao_fixa_convertivel = (item.sugestao_fixa_convertivel / item.multiplo_compra);
      item.estoque = (item.estoque / item.multiplo_compra);
      item.estoque_futuro_tempo_ressuprimento = (item.estoque_futuro_tempo_ressuprimento / item.multiplo_compra);
      item.sugestao = (item.sugestao / item.multiplo_compra);
      item.preco_custo = ((item.preco_custo || 0) * item.multiplo_compra);

      if (item.estoque_transito) {
        item.estoque_transito = ((item.estoque_transito) / item.multiplo_compra);
      }

      if (item.tipo_fator_conversao === 'M') {
        item.lote_minimo = item.loteMinimoAuxiliar;
        item.estoque_minimo =  (item.estoque_minimo > 0) ? item.estoque_minimo * item.multiplo_compra : 0;
      } else {
        item.lote_minimo =  item.loteMinimoAuxiliar/item.multiplo_compra;
        item.estoque_minimo =  (item.estoque_minimo > 0) ? item.estoque_minimo /item.multiplo_compra : 0;
      }

      item.lastro_palete = (item.lastro_palete / item.multiplo_compra);

      return item;
    },
    converterParaEmbMinima(item){
      item.estoque_pendente = (item.estoque_pendente * item.multiplo_compra);
      item.sugestao_fixa_convertivel = (item.sugestao_fixa_convertivel * item.multiplo_compra);
      item.estoque = (item.estoque * item.multiplo_compra);
      item.estoque_futuro_tempo_ressuprimento = (item.estoque_futuro_tempo_ressuprimento * item.multiplo_compra);
      item.sugestao = (item.sugestao * item.multiplo_compra);
      item.preco_custo = ((item.preco_custo || 0) / item.multiplo_compra);

      if (item.estoque_transito) {
        item.estoque_transito = ((item.estoque_transito) * item.multiplo_compra);
      }

      if (item.tipo_fator_conversao === 'M') {
        item.lote_minimo = item.multiplo_compra * item.loteMinimoAuxiliar;
        item.estoque_minimo = (item.estoque_minimo > 0) ? item.multiplo_compra / item.estoque_minimo : 0;
      } else {
        item.lote_minimo = item.loteMinimoAuxiliar || 1;
        item.estoque_minimo = (item.estoque_minimo > 0) ? item.multiplo_compra * item.estoque_minimo : 0;
      }

      item.lastro_palete = (item.lastro_palete * item.multiplo_compra);

      return item;
    }
  }
}

